import { AppDispatch } from "../../store";
import { siteContextRequest } from "../../redux/siteContextRequest";
import config from "../../config";
import { GeoJSON } from "geojson";

export const fetchDesignGradeBoundary = (
  customerId: string,
  siteId: string,
) => async (dispatch: AppDispatch): Promise<GeoJSON> => {
  const response = await dispatch(
    siteContextRequest(customerId, siteId, {
      method: "POST",
      url: `${config.endpoints.backofficeApi}/${customerId}/${siteId}/design_grade_boundary`,
    }),
  );

  // TODO: add validation, e.g. using JSON schema

  return response.data.body.content;
};
